/**
 * GitHub renders a file as `<div id="file"><article class="markdown-body">…`
 * with a permalink anchor beside every heading. Only the article's content is
 * kept, without the anchors: their `href`s point at ids GitHub assigns from
 * script, so they would lead nowhere in the portal.
 */
export const renderedFileHtml = (html: string) => {
  const document = new DOMParser().parseFromString(html, 'text/html');
  const content = document.querySelector('article') ?? document.body;
  content.querySelectorAll('a.anchor').forEach(anchor => anchor.remove());
  return content.innerHTML.trim();
};
